<app-page-modifications>
  <app-header class="full-width"></app-header>
  <main id="content" class="js-content" role="main">
    <div class="grid-row">
      <div class="column-full">
        <p class="aa-title-size" tabindex="0">
          <strong>Choose size of words and numbers</strong>
        </p>
        <div class="grid-row">
          <div class="column-float">
            <fieldset>
              <div class="multiple-choice" *ngFor="let selectedFont of fontSettings;">
                <input type="radio"
                      value="{{selectedFont.val}}"
                      id="font-{{selectedFont.val}}"
                      name="font-size"
                      [checked]="selectedSize === selectedFont.val"
                      (change)="selectionChange(selectedFont.val)">
                <label class="aa-copy-size-{{selectedFont.val}}" for="font-{{selectedFont.val}}"><span>{{selectedFont.label}}</span></label>
              </div>
            </fieldset>
          </div>
          <div class="column-float" aria-hidden="true">
            <div *ngIf="validSelection" class="preview-box aa-contrast-border">
              <div class="badge aa-copy-size-{{selectedSize}} aa-contrast-invert">Size preview</div>
              <div class="preview-content">
                  <div class="question-text aa-question-size-{{selectedSize}}">123</div>
                  <table>
                      <tr>
                          <td><button class="numpad-button-preview-{{selectedSize}} aa-contrast-invert" type="button" tabindex="-1"><span>1</span></button></td>
                          <td><button class="numpad-button-preview-{{selectedSize}} aa-contrast-invert" type="button" tabindex="-1"><span>2</span></button></td>
                          <td><button class="numpad-button-preview-{{selectedSize}} aa-contrast-invert" type="button" tabindex="-1"><span>3</span></button></td>
                      </tr>
                  </table>
              </div>
            </div>
            <div *ngIf="!validSelection" class="notice warning-box" tabindex="0">
                <i class="icon icon-important">
                    <span class="visually-hidden">Warning</span>
                </i>
                <p>
                  This size won't work on your screen. Please choose another size or use a device with a larger screen.
                </p>
            </div>
          </div>
        </div>
        <p class="aa-copy-size" tabindex="0">
          If you don’t need this setting, please tell your teacher and <a routerLink="/sign-out" >sign out</a>
        </p>
        <button [disabled]="!validSelection" class="button aa-button-size aa-contrast-button" (click)="onClick()" id="next">Next</button>
      </div>
    </div>
  </main>
</app-page-modifications>
